import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function GuestLogin() {
  const navigate = useNavigate();
  const { checkAuth } = useApp();
  const done = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const token = params.get("token");
    if (!token) { navigate("/"); return; }
    (async () => {
      try {
        localStorage.setItem("sb_token", token);
        await api.get("/auth/me");
        await checkAuth();
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        localStorage.removeItem("sb_token");
        setError(true);
        setTimeout(() => navigate("/"), 1500);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="mx-auto max-w-md min-h-[100dvh] flex flex-col items-center justify-center gap-4" style={{ background: "var(--app-bg)" }}>
      <p className="font-heading text-gray-600">{error ? "Anmeldung fehlgeschlagen…" : "Gastzugang wird geöffnet…"}</p>
    </div>
  );
}
